
  import { Component, Vue } from "vue-property-decorator";

  @Component({})
  export default class Tip2 extends Vue {}
